import { request } from "@/lib/request";
import type { 
  SendCodeParams, 
  SendCodeResponse, 
  RegisterParams, 
  RegisterResponse, 
  LoginParams, 
  LoginResponse, 
  ResetPasswordParams,
  UserResponse
} from "@/types/user";

export async function sendCode(data: SendCodeParams) {
  return request<SendCodeResponse>('/api/auth/send-code', {
    method: 'POST',
    data,
  });
}

export async function register(data: RegisterParams) {
  return request<RegisterResponse>('/api/auth/register', {
    method: 'POST',
    data,
  });
}

export async function getOemContext() {
  return request<{ is_oem: boolean; oem_id?: string }>('/api/auth/oem-context', {
    method: 'GET',
  });
}

export async function login(data: LoginParams) {
  return request<LoginResponse>('/api/auth/login', {
    method: 'POST',
    data,
  });
}

export async function resetPassword(data: ResetPasswordParams) {
  return request<void>('/api/auth/reset-password', {
    method: 'POST',
    data,
  });
}

export async function getUserInfo(options?: { skip401Redirect?: boolean }) {
  return request<UserResponse>('/api/auth/me', {
    method: 'GET',
    ...options
  });
}

export async function updateProfile(data: { nickname?: string; avatar?: string }) {
  return request<UserResponse>('/api/auth/profile', {
    method: 'POST',
    data
  });
}

export async function updatePassword(data: { oldPassword: string; newPassword: string }) {
  return request<void>('/api/auth/password', {
    method: 'POST',
    data
  });
}

export async function exitImpersonation() {
  return request<void>('/api/auth/impersonation/exit', {
    method: 'POST',
  });
}
